import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63')
];

export const server_loads = [];

export const dictionary = {
		"/[[lang=locale]]/(index-page)": [11,[2],[3]],
		"/[[lang=locale]]/(non-auth)/accept-invite": [52,[2],[3]],
		"/[[lang=locale]]/(need-unauth)/account-recovery": [45,[2,10],[3]],
		"/contract-review/preview": [63],
		"/[[lang=locale]]/error": [62,[2],[3]],
		"/[[lang=locale]]/(non-auth)/esign": [53,[2],[3]],
		"/[[lang=locale]]/(non-auth)/esign/auth": [54,[2],[3]],
		"/[[lang=locale]]/(non-auth)/esign/exit": [55,[2],[3]],
		"/[[lang=locale]]/(non-auth)/esign/view": [56,[2],[3]],
		"/[[lang=locale]]/(non-auth)/like-reload": [57,[2],[3]],
		"/[[lang=locale]]/(non-auth)/login/sso/[ssoPartnerType]": [58,[2],[3]],
		"/[[lang=locale]]/(non-auth)/logout": [59,[2],[3]],
		"/[[lang=locale]]/(need-unauth)/reset-password-from-email": [46,[2,10],[3]],
		"/[[lang=locale]]/(need-unauth)/sign-in": [47,[2,10],[3]],
		"/[[lang=locale]]/(need-unauth)/sign-up/direct/email-input": [48,[2,10],[3]],
		"/[[lang=locale]]/(need-unauth)/sign-up/direct/set-password": [49,[2,10],[3]],
		"/[[lang=locale]]/(need-unauth)/sign-up/direct/user-name": [50,[2,10],[3]],
		"/[[lang=locale]]/(non-auth)/sign-up/invite": [60,[2],[3]],
		"/[[lang=locale]]/(non-auth)/sso-sign-in-callback": [61,[2],[3]],
		"/[[lang=locale]]/(need-unauth)/sso-sign-up-callback": [51,[2,10],[3]],
		"/[[lang=locale]]/(need-auth)/welcome": [44,[2,4],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]": [12,[2,4,5],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/account/profile": [26,[2,4,5,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/ask-ai": [13,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/calendar": [14,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/contract-draft": [15,[2,4,5,6,7],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/contract-draft/agent": [16,[2,4,5,6,7],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/contract-draft/import": [17,[2,4,5,6,7],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/contract-review": [18,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/documents": [19,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/drafts": [20,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/esign": [21,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/esign/new": [40,[2,4,5,9],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/esign/new/prepare": [41,[2,4,5,9],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/esign/new/signers": [42,[2,4,5,9],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/esign/new/upload": [43,[2,4,5,9],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/esign/send": [22,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/esign/send/contracts": [23,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/home": [24,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/members": [27,[2,4,5,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(main)/search": [25,[2,4,5,6],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings": [28,[2,4,5,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings/account": [29,[2,4,5,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings/apps": [30,[2,4,5,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings/billing": [31,[2,4,5,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings/company": [32,[2,4,5,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings/contract-types": [33,[2,4,5,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings/members": [34,[2,4,5,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings/notifications": [35,[2,4,5,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings/plan": [36,[2,4,5,8],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings/plan/checkout": [37,[2,4,5],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings/plan/credit-checkout": [38,[2,4,5],[3]],
		"/[[lang=locale]]/(need-auth)/[workspaceName]/(settings)/settings/usage": [39,[2,4,5,8],[3]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),

	reroute: (() => {})
};

export { default as root } from '../root.svelte';